import React from "react";
import { isSameDay } from "date-fns";
import { Virtualizer } from "@tanstack/react-virtual";

interface CalendarDaysHeaderVirtualizedProps {
  days: Date[];
  today: Date;
  columnVirtualizer: Virtualizer<HTMLDivElement, Element>;
  rowHeight: number;
}

const CalendarDaysHeaderVirtualized: React.FC<CalendarDaysHeaderVirtualizedProps> = ({
  days,
  today,
  columnVirtualizer,
  rowHeight,
}) => (
  <div
    className="flex sticky z-20 bg-white border-b"
    style={{ height: rowHeight, top: rowHeight }}
  >
    {columnVirtualizer.getVirtualItems().map((column) => {
      const date = days[column.index];
      const isToday = isSameDay(date, today);
      const bgClass = isToday ? "bg-blue-100" : "bg-gray-50";
      const weekdayClass = isToday ? "text-brand-primary" : "text-gray-400";
      const dayNumberClass = isToday ? "text-brand-primary" : "text-gray-700";

      return (
        <div
          key={column.key}
          style={{
            position: "absolute",
            left: column.start,
            width: column.size,
            height: rowHeight,
          }}
          className={`border-r flex flex-col items-center justify-center ${bgClass}`}
        >
          <span
            className={`text-[10px] uppercase leading-none ${weekdayClass}`}
          >
            {date.toLocaleDateString("es-MX", { weekday: "short" })}
          </span>
          <span
            className={`text-xs font-medium leading-none mt-1 transition rounded-full px-1.5 ${dayNumberClass}`}
          >
            {date.getDate()}
          </span>
        </div>
      );
    })}
  </div>
);

export default CalendarDaysHeaderVirtualized;
